import { IconMail } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { usePostApi } from "src/hooks";
import { Notification } from "src/utils/Notification";

const SendMailButton = () => {
  const { userId } = useParams();
  const { post, isLoading } = usePostApi();

  const handleSendEmail = async () => {
    await post({
      request: "send-welcome",
      body: { params: { userid: userId } },
      onSuccess: () =>
        Notification(
          "Success",
          "The welcome mail has been sent to this user successfully",
          "green",
        ),
    });
  };

  return (
    <ConfirmationButton
      buttonProps={{
        leftIcon: <IconMail size={"1.4rem"} />,
        variant: "outline",
      }}
      modalText="Are you sure you want to send this user a welcome mail?"
      loading={isLoading}
      onConfirm={handleSendEmail}>
      Send Welcome Mail
    </ConfirmationButton>
  );
};

export default SendMailButton;
